import { useSelector } from "react-redux";
import clsx from "clsx";
import { isCompleteFilterUrl } from "~/utils/catalog/filterUrl";
import styles from "./index.module.scss";

export default function Props({ props, filterUrl }) {
  const { props: allProps } = useSelector((state) => state.props);
  return (
    <>
      {(Array.isArray(props) ? props : [])?.map((prop) => (
        <div key={prop.ID} className={clsx(styles.Prop)}>
          <span className={clsx(styles.PropName)}>
            {allProps[prop.CODE]?.NAME || prop.NAME}
            {allProps[prop.CODE]?.HINT && (
              <span className={clsx(styles.Hint)}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
                    fill="#9DA4AE"
                  />
                  <path
                    d="M12.0098 17C11.4575 17 11.0098 16.5523 11.0098 16L11.0098 12C11.0098 11.4477 11.4575 11 12.0098 11C12.5621 11 13.0098 11.4477 13.0098 12L13.0098 16C13.0098 16.5523 12.5621 17 12.0098 17Z"
                    fill="#9DA4AE"
                  />
                  <path
                    d="M13.0098 8C13.0098 8.55229 12.5621 9 12.0098 9L11.9998 9C11.4475 9 10.9998 8.55229 10.9998 8C10.9998 7.44771 11.4475 7 11.9998 7L12.0098 7C12.562 7 13.0098 7.44771 13.0098 8Z"
                    fill="#9DA4AE"
                  />
                </svg>

                <span className={styles.HintText}>
                  {allProps[prop.CODE]?.HINT}
                </span>
              </span>
            )}
          </span>

          <span className={clsx(styles.PropValue)}>
            {prop.VALUE}
            <>
              {(prop.NAME === "Электрика в комплекте" ||
                prop.CODE === "ELEKTRIKA_V_KOMPLEKTE") &&
                prop.VALUE === "нет" &&
                isCompleteFilterUrl(filterUrl) && (
                  <a
                    href={`/catalog/elektrika_farkopov/filter/${filterUrl}`}
                    rel="noreferrer"
                    target="_blank"
                  >
                    подобрать
                  </a>
                )}
            </>
          </span>
        </div>
      ))}
    </>
  );
}
